const topicItems = [
  { label: '明星恋情', count: '856万讨论', size: 'lg' },
  { label: '综艺爆料', count: '723万讨论', size: 'lg' },
  { label: '网红翻车', count: '691万讨论', size: 'md' },
  { label: '影视八卦', count: '587万讨论', size: 'md' },
  { label: '品牌代言', count: '512万讨论', size: 'md' },
  { label: '幕后揭秘', count: '468万讨论', size: 'sm' },
  { label: '音乐吃瓜', count: '423万讨论', size: 'sm' },
  { label: '社交热点', count: '389万讨论', size: 'sm' },
  { label: '行业黑幕', count: '356万讨论', size: 'sm' },
  { label: '艺人纠纷', count: '298万讨论', size: 'sm' },
  { label: '年度大瓜', count: '267万讨论', size: 'sm' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1024px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            话题广场
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">
            51吃瓜视频热门话题标签，快速发现您感兴趣的吃瓜方向
          </p>
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          {topicItems.map((item, i) => (
            <div
              key={i}
              className={`group flex flex-col items-center bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-200/60 transition-colors cursor-pointer ${
                item.size === 'lg'
                  ? 'px-6 py-4 min-w-[160px]'
                  : item.size === 'md'
                  ? 'px-5 py-3.5 min-w-[140px]'
                  : 'px-4 py-3 min-w-[120px]'
              }`}
            >
              <span className={`font-heading ${
                item.size === 'lg'
                  ? 'text-base text-foreground-900'
                  : item.size === 'md'
                  ? 'text-sm text-foreground-800'
                  : 'text-sm text-foreground-700'
              } group-hover:text-primary-600 transition-colors whitespace-nowrap`}>
                #{item.label}
              </span>
              <span className="text-xs text-foreground-400 mt-1">{item.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}